export enum ErrorMessage {
    ImageRemovedDuringLoad = 'Image was removed while loading',
    ImageLoadingFailed = 'Could not load image',
    ResizeObservableLoopLimit = 'ResizeObserver loop limit exceeded',
    ResizeObservableLoopCompleted = 'ResizeObserver loop completed with undelivered notifications'
}
